import type { RouteRecordRaw } from 'vue-router'

const orderRoutes: RouteRecordRaw[] = [
  {
    path: 'orders',
    name: 'Orders',
    component: () => import('@/pages/orders/index.vue'),
    meta: { title: '订单管理', requiresPsi: true },
  },

  {
    path: 'orders/operation-brief',
    name: 'OperationBrief',
    component: () => import('@/pages/orders/operation-brief.vue'),
    meta: { title: '项目运营简报', requiresPsi: true },
  },
  {
    path: 'orders/platform-stores',
    name: 'PlatformStores',
    component: () => import('@/pages/orders/platform-stores.vue'),
    meta: { title: '平台店铺', requiresPsi: true },
  },
  {
    path: 'orders/platform-import',
    name: 'PlatformOrderImport',
    component: () => import('@/pages/orders/platform-order-import.vue'),
    meta: { title: '平台订单', requiresPsi: true },
  },
  {
    path: 'order-audit',
    name: 'SalesOrderAudit',
    redirect: { path: '/tasks/approval', query: { businessType: 'sales_order' } },
    meta: { title: '订单审核', requiresPsi: true },
  },
  {
    path: 'finance/payment-audit',
    name: 'PaymentAudit',
    component: () => import('@/pages/finance/payment-audit/Index.vue'),
    meta: { title: '订单付款审核', requiresPsi: true },
  },
  {
    path: 'finance/customer-prestore-audit',
    name: 'CustomerPrestoreAudit',
    component: () => import('@/pages/finance/customer-prestore-audit/Index.vue'),
    meta: { title: '充值提现审核', requiresPsi: true },
  },
  {
    path: 'finance/order-refund-settlement',
    name: 'OrderRefundSettlement',
    component: () => import('@/pages/finance/order-refund-settlement/Index.vue'),
    meta: { title: '售后退款结算', requiresPsi: true },
  },
  {
    path: 'after-sales',
    name: 'AfterSales',
    component: () => import('@/pages/after-sales/index.vue'),
    meta: { title: '售后管理', requiresPsi: true },
  },
  {
    path: 'after-sales-workbench',
    name: 'AfterSalesWorkbench',
    component: () => import('@/pages/after-sales-workbench/index.vue'),
    meta: { title: '售后工作台', requiresPsi: true },
  },
  {
    path: 'after-sales-audit',
    name: 'AfterSalesAudit',
    redirect: { path: '/tasks/approval', query: { businessType: 'after_sales' } },
    meta: { title: '售后审核', requiresPsi: true },
  },
  {
    path: 'logistics-compensation',
    name: 'LogisticsCompensation',
    component: () => import('@/pages/logistics-compensation/index.vue'),
    meta: { title: '物流赔付管理', requiresPsi: true },
  },
]

export default orderRoutes
